import React, { Dispatch, SetStateAction } from "react"
import { Form, useFormikContext } from "formik"
import { Formik } from "../../../../../../../shared/components/forms/SchemaFormik"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../../../localization/useDateTime"
import {
    CreateUpdateMerchantFormValues,
    WeeklySchedule,
} from "../../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"
import { useMerchantOpeningHoursValidationScheme } from "../../hooks/useMerchantOpeningHoursValidationScheme"
import { prepareInitialValues } from "./helpers/prepareInitialValues"
import { CreateOpeningHoursFormValues } from "./openingHoursTypes"
import { convertToOpeningHours } from "./helpers/convertToOpeningHours"
import { OpeningHoursFormContent } from "./OpeningHoursFormContent"

type OpeningHoursDialogProps = Readonly<{
    dialogState: boolean
    setDialogState: Dispatch<SetStateAction<boolean>>
    initialData?: WeeklySchedule[]
}>

export const OpeningHoursDialog = ({ dialogState, setDialogState, initialData }: OpeningHoursDialogProps) => {
    const { setFieldValue } = useFormikContext<CreateUpdateMerchantFormValues>()
    const dateTimeFactory = useDateTime()

    const initialValues = prepareInitialValues(dateTimeFactory, initialData)

    const validationSchema = useMerchantOpeningHoursValidationScheme()

    const handleSubmit = (values: CreateOpeningHoursFormValues) => {
        setFieldValue("openingHours", convertToOpeningHours(values))
        setDialogState(false)
    }

    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="merchant-update-account-opening-hours-dialog-title">
                    <span>Opening hours</span>
                </LocalizedStrict>
            }
            open={dialogState}
            onClose={() => setDialogState(false)}
            maxWidthProp="sm"
            scroll="body"
        >
            <Formik<CreateOpeningHoursFormValues>
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnChange={false}
            >
                <Form>
                    <OpeningHoursFormContent />
                </Form>
            </Formik>
        </StandardDialog>
    )
}
